/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/classnames-order */
import type * as React from 'react';
import { useTracking } from 'react-tracking';
import { Helmet } from 'react-helmet';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';
import { useMount } from '@simplywallst/ui-core';
import { cn } from '@simplywallst/ui-core/next';

import DocumentHeader from '@/components/DocumentHeader';

import { withFlag } from '../withFlag';
import { getStripePricingTableConfig } from './utils';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'stripe-pricing-table': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

const GiftCardPurchase = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: 'page',
  });

  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  const pricingTableConfig = getStripePricingTableConfig();

  return (
    <Track>
      <DocumentHeader title="Gift Card Purchase" />
      <Helmet>
        <script async src="https://js.stripe.com/v3/pricing-table.js"></script>
      </Helmet>
      <div
        className={cn(
          'mt-10 flex',
          isMobileScreen ? 'min-w-[300px]' : 'min-w-[900px]'
        )}
        data-testid="stripe-gift-card-widget"
      >
        <stripe-pricing-table
          pricing-table-id={pricingTableConfig.id}
          publishable-key={pricingTableConfig.publishableKey}
          style={{
            minWidth: isMobileScreen ? '300px' : '900px',
            maxWidth: '100%',
          }}
        ></stripe-pricing-table>
      </div>
    </Track>
  );
};

const FlagWrapper = withFlag(GiftCardPurchase);
export { FlagWrapper as GiftCardPurchase };
